import { render, staticRenderFns } from "./HomeViewold.vue?vue&type=template&id=4dd1f3dc&scoped=true"
import script from "./HomeViewold.vue?vue&type=script&lang=js"
export * from "./HomeViewold.vue?vue&type=script&lang=js"
import style0 from "./HomeViewold.vue?vue&type=style&index=0&id=4dd1f3dc&prod&lang=css"
import style1 from "./HomeViewold.vue?vue&type=style&index=1&id=4dd1f3dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd1f3dc",
  null
  
)

export default component.exports